import toast from 'react-hot-toast';
import { ApiCallError } from './ApiCallError';
import { getApiCallErrorMessage } from './getApiCallErrorMessage';

const SILENT_STATUSES = new Set([401, 412, 429]);
const UNKNOWN_ERROR_MESSAGE = 'Something went wrong. Please try again later.';

export const notifyApiCallError = (error: unknown) => {
  if (!(error instanceof ApiCallError)) {
    toast.error(UNKNOWN_ERROR_MESSAGE);
    return;
  }
  if (error.reported || error.refreshOutcome === 'auth-failure') {
    return;
  }
  if (error.status !== undefined && SILENT_STATUSES.has(error.status)) {
    return;
  }
  toast.error(getApiCallErrorMessage(error));
};
